module.exports = __webpack_public_path__ + "static/media/content-dau-khi-1.270ade53.webp";